import { render, staticRenderFns } from "./simplifyOwnerRepair.vue?vue&type=template&id=1a5ed690&scoped=true"
import script from "./simplifyOwnerRepair.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerRepair.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerRepair.vue?vue&type=style&index=0&id=1a5ed690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ed690",
  null
  
)

export default component.exports